import moment from "moment";
import { determineIfTheJCodeFieldShouldBeEditable } from "./determineIfTheFieldShouldBeEditable";

export const checkIfVisitCompletedIsBlank = (
  visitCompleted: number | undefined | null,
) => {
  if (visitCompleted === undefined || visitCompleted === null) {
    return true;
  }
  return false;
};

export const checkIfVisitsRemainingIsBlank = (
  visitsRemaining: number | undefined | null,
) => {
  if (visitsRemaining === undefined || visitsRemaining === null) {
    return true;
  }
  return false;
};

export const checkIfNumVisitsIsBlank = (
  numVisits: number | undefined | null,
) => {
  if (numVisits === undefined || numVisits === null) {
    return true;
  }
  return false;
};

export const checkIfNumVisitsMatchesRemainingAndCompleted = (
  numVisits: number | undefined | null,
  visitsRemaining: number | undefined | null,
  visitsCompleted: number | undefined | null,
) => {
  if (
    numVisits === undefined ||
    numVisits === null ||
    visitsRemaining === undefined ||
    visitsRemaining === null ||
    visitsCompleted === undefined ||
    visitsCompleted === null ||
    numVisits !== visitsRemaining + visitsCompleted
  ) {
    return false;
  }
  return true;
};

export const checkIfStringIsValidNumber = (str: string | undefined | null) => {
  if (str === undefined || str === "" || isNaN(Number(str))) {
    return false;
  }
  return true;
};

export const checkIfDateIsInCorrectFormat = (
  date: string | undefined,
  format: string = "MM/DD/YYYY",
) => {
  if (
    date === undefined ||
    date === "" ||
    !moment(date, format, true).isValid()
  ) {
    return false;
  }
  return true;
};

export const checkIfDateIsEarlierThanDateOfService = (
  date: string | undefined,
  dateOfService: string | undefined,
) => {
  // First check if both dates are valid
  if (
    date === undefined ||
    date === "" ||
    dateOfService === undefined ||
    dateOfService === "" ||
    !moment(date, "MM/DD/YYYY", true).isValid() ||
    !moment(dateOfService, "MM/DD/YYYY", true).isValid()
  ) {
    return false;
  }

  // Only compare if both dates are valid
  const result = moment(date, "MM/DD/YYYY", true).isSameOrBefore(
    moment(dateOfService, "MM/DD/YYYY", true),
  );
  return result;
};

export const checkIfDateIsLaterThanDateOfService = (
  date: string | undefined,
  dateOfService: string | undefined,
) => {
  // First check if both dates are valid
  if (
    date === undefined ||
    date === "" ||
    dateOfService === undefined ||
    dateOfService === "" ||
    !moment(date, "MM/DD/YYYY", true).isValid() ||
    !moment(dateOfService, "MM/DD/YYYY", true).isValid()
  ) {
    return false;
  }

  // Only compare if both dates are valid
  const result = moment(date, "MM/DD/YYYY", true).isSameOrAfter(
    moment(dateOfService, "MM/DD/YYYY", true),
  );
  return result;
};

export const checkIfJCodeIsBlank = (jCode: string | undefined | null) => {
  if (jCode === undefined || jCode === null || jCode.trim() === "") {
    return true;
  }
  return false;
};

export const checkIfJCodeFieldHasError = (
  authStatus: string,
  jCode: string,
) => {
  const isJCodeBlank = checkIfJCodeIsBlank(jCode);
  const isAuthStatusValid = determineIfTheJCodeFieldShouldBeEditable(
    authStatus,
    jCode,
  );
  return isJCodeBlank && isAuthStatusValid;
};
